// extracted by mini-css-extract-plugin
export const container = "Catering-module--container--3lI6R";
export const menuBG = "Catering-module--menuBG--2B7Rv";
export const link = "Catering-module--link--2rjOb";
export const cardContainer = "Catering-module--cardContainer--UkTpv";
export const choicesContainer = "Catering-module--choicesContainer--3FNX5";